import React, { useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';

// Shown on the Transaction Coordinator's profile. Connecting is a one-time sign-in with the Google account
// that should send key-date invitations. The connect link is set in REACT_APP_CALENDAR_CONNECT_URL when
// the server functions are deployed.
const CONNECT_URL = process.env.REACT_APP_CALENDAR_CONNECT_URL || '';

const card = { background: '#ffffff', border: '1px solid #d8c9a8', borderRadius: 10, padding: 20, marginBottom: 16 };
const h2 = { fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px' };
const muted = { fontSize: 14, color: '#5B6270', lineHeight: 1.5, margin: '0 0 12px' };
const btn = { display: 'inline-block', padding: '10px 16px', borderRadius: 6, fontWeight: 700, fontSize: 14, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF' };

export default function CalendarConnectCard() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    get(ref(database, 'system/googleCalendarStatus'))
      .then((snap) => setStatus(snap.exists() ? snap.val() : { connected: false }))
      .catch(() => setStatus({ connected: false }));
  }, []);

  return (
    <div style={card}>
      <h2 style={h2}>Google Calendar</h2>
      {status?.connected ? (
        <p style={muted}>Connected. Key dates for your deals are added to the shared calendar, and invitations go to the agent, co-agent, buyer side, and client.</p>
      ) : (
        <>
          <p style={muted}>Connect the Google account that should send key-date invitations for deals. You only need to do this once.</p>
          <ol style={{ ...muted, paddingLeft: 20 }}>
            <li>Click Connect Google Calendar below.</li>
            <li>Sign in with that Google account and approve calendar access.</li>
            <li>Google may say the app isn't verified. Click Advanced, then continue.</li>
            <li>When the page says Connected, close it. This card will update the next time you open your profile.</li>
          </ol>
          {CONNECT_URL ? (
            <a href={CONNECT_URL} target="_blank" rel="noopener noreferrer" style={btn}>Connect Google Calendar</a>
          ) : (
            <p style={muted}>Not set up yet. Kelly will turn this on when Resi goes live.</p>
          )}
        </>
      )}
    </div>
  );
}
